module.exports = __webpack_public_path__ + "img/solution5_01.1722a5d5.jpg";